<template>
  <div class="learnManage">
        <el-container>
          <el-main>
            <div class="div">
              <el-button @click="addLearn">+&nbsp;新增</el-button>
            </div>
            <el-table
              :data="tableData"
              header-row-class-name="header-row-class-name"
              :height="height"
              border
              v-loading="loading"
              width="100%"
              :default-sort = "{prop: 'id', order: 'descending'}"
            >
              <el-table-column
                sortable
                prop="id"
                label="ID号">
              </el-table-column>
              <el-table-column
                sortable
                prop="ordinal"
                label="排序号">
              </el-table-column>
              <el-table-column
                prop="name"
                label="学段名">
              </el-table-column>

              <el-table-column
                label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.used === true" style="color: #00ff00"> 启用</span>
                  <span v-if="scope.row.used === false" style="color: #ff0000">禁用</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作">
                <template slot-scope="scope">
                  <el-button  type="text" size="small" @click="editLearn(scope.row.id,scope.row)">编辑</el-button>
                  <el-button  type="text" size="small" @click="disable(scope.row.id)" v-if="scope.row.used == true">禁用</el-button>
                  <el-button  type="text" size="small" @click="enable(scope.row.id)" v-if="scope.row.used == false">启用</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <!-- 编辑框 -->
          <edit-dialog  v-model="learnDialogVisible" :rowData="rowData" :id="id" @success="editSuccess"></edit-dialog>

        </el-container>
  </div>
</template>
<script>
import { Container, Header, Main, Input, Form, FormItem, Button} from 'element-ui'
import learnService from '@/service/learnService'
import editDialog from './edit-dialog'
export default {

  components: {
    elContainer: Container,
    elHeader: Header,
    elMain: Main,
    elInput: Input,
    elForm: Form,
    elFormItem: FormItem,
    elButton: Button,
    editDialog: editDialog
  },
  name: 'learnManage',
  data () {
    return {
      id: 0,
      height: this.SysConstant.winHeight - 240,
      rowData: {},
      learnDialogVisible: false,
      tableData: [],
      loading: false
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        let data = await learnService.fetchData()
        if (data) {
          this.tableData = data
        } else {
          this.tableData = []
        }
      } catch (e) {
        this.$message.error(e && e.msg)
      }
      this.loading = false
    },
    // 启用
    async enable (id) {
      try {
        await learnService.enableOrDisable({id: id, use: true})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 禁用
    async disable (id) {
      this.$confirm('此操作将禁用该学段, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await learnService.enableOrDisable({id: id, use: false})
        this.$message.success(this.SysConstant.success)
        this.fetchData()
      }).catch((e) => {
       // this.$message.error(e && e.msg)
      })
    },
    addLearn () {
      this.id = 0
      this.learnDialogVisible = true
    },
    editLearn (id, row) {
      this.id = id
      this.rowData = row
      this.learnDialogVisible = true
    },
    editSuccess () {
      this.id = 0
      this.rowData = {}
      this.learnDialogVisible = false
      this.$message.success(this.SysConstant.success)
      this.fetchData()
    }
  }

}
</script>
<style scoped>

</style>
<style type="text/css">
  .learnManage .el-main{
    background-color:#f3f5f8;
  }
  .learnManage .el-main .div{
    background-color: #ffffff;
    color: #333;
    line-height: 60px;
    height:60px;
    margin-top: -10px;
    margin-bottom: 5px;
  }
  .learnManage .div .el-button{
    background-color: #00aaff;
    color:#fff;
    float: left;
    margin:10px;
  }
  .learnManage  .clear{
    clear: both;
  }

</style>



// WEBPACK FOOTER //
// src/pages/layout/learn-manage/index.vue